import { useState } from 'react'
import { supabase } from '../../utils/supabaseClient'
import { useNavigate } from 'react-router-dom'
import styles from './UpdatePassword.module.scss'

export default function UpdatePassword() {
  const [loading, setLoading] = useState(false)
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState(null)
  const [message, setMessage] = useState(null)
  const navigate = useNavigate()

  const handlePasswordUpdate = async (event) => {
    event.preventDefault()
    setError(null)
    setMessage(null)

    if (password !== confirmPassword) {
      setError('Las contraseñas no coinciden')
      return
    }

    if (password.length < 6) {
      setError('La contraseña debe tener al menos 6 caracteres')
      return
    }

    setLoading(true)

    try {
      const { error } = await supabase.auth.updateUser({
        password: password
      })

      if (error) throw error

      setMessage('Contraseña actualizada correctamente')
      setTimeout(() => {
        navigate('/', { replace: true })
      }, 2000)
    } catch (err) {
      console.error('Password update error:', err)
      setError(err.message || 'Error updating password')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className={styles.updatePasswordContainer}>
      <div className={styles.formContainer}>
        <article className={styles.description}>
          <p>Actualice su contraseña</p>
        </article>
        {error && <div className={styles.error}>{error}</div>}
        {message && <div className={styles.success}>{message}</div>}
        <form onSubmit={handlePasswordUpdate}>
          <div>
            <input
              className={styles.inputField}
              type="password"
              placeholder="Nueva contraseña"
              value={password}
              required={true}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div>
            <input
              className={styles.inputField}
              type="password"
              placeholder="Confirmar contraseña"
              value={confirmPassword}
              required={true}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </div>
          <div>
            <button className={styles.button} disabled={loading}>
              {loading ? <span>Loading</span> : <span>Actualizar</span>}
            </button>
          </div>
        </form>
        <button 
          className={styles.switchButton} 
          onClick={() => navigate('/')}
        >
          Regresar a inicio
        </button>
      </div>
    </div>
  )
} 